import React, { Suspense, forwardRef } from 'react';
import { cn } from '../lib/utils';

/**
 * The rich text editor (BlockNote with its Mantine, Tiptap and Yjs parts, about 3 MB)
 * in its own chunk: the app starts without it, and it is fetched right after the
 * start (preloadEditor), so a task or a document never waits for it in practice.
 * Same props and ref as BlockNoteEditor.
 */
const load = () => import('./BlockNoteEditor');
const Editor = React.lazy(load);

export const preloadEditor = () => load().catch(() => {});

const LazyBlockNoteEditor = forwardRef(function LazyBlockNoteEditor(props, ref) {
  return (
    <Suspense fallback={<div className={cn('w-full', props.className)} style={{ minHeight: props.minHeight || '120px' }} aria-busy="true" />}>
      <Editor ref={ref} {...props} />
    </Suspense>
  );
});

export default LazyBlockNoteEditor;
